import Axios from '../config/Axios';

export default function getNewDocument() {
  return Axios.get('document/form/create').then((oResponse) => oResponse.data);
}
